import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import css_248z from './accordion-item-updated.scss.js';
import img from '../../../../assets/images/accordion-icon.svg.js';

class AccordionItemUpdated extends s {
    constructor() {
        super(...arguments);
        this.title = '';
        this.titleColor = '';
        this.subtitle = '';
        this.imageUrl = '';
        this.imageAlt = '';
        this.imageDecorative = '';
        this.imageSize = 'medium';
        this.expanded = false;
        this.disabled = false;
        this.rtl = false;
        this.contentId = '';
        this.triggerId = '';
    }
    connectedCallback() {
        super.connectedCallback();
        const uniqueId = crypto.randomUUID();
        this.contentId = `accordion-panel-${uniqueId}`;
        this.triggerId = `accordion-trigger-${uniqueId}`;
    }
    firstUpdated() {
        var _a;
        const slot = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('slot[name="accordion-content"]');
        slot === null || slot === void 0 ? void 0 : slot.addEventListener('slotchange', () => {
            if (this.expanded) {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        this.updatePanelHeight();
                    });
                });
            }
        });
    }
    handleToggle(e) {
        if (this.disabled)
            return;
        e.preventDefault();
        this.expanded = !this.expanded;
        this.dispatchEvent(new CustomEvent('accordion-toggle', {
            bubbles: true,
            composed: true,
            detail: {
                expanded: this.expanded,
                item: this,
            },
        }));
        if (this.expanded) {
            requestAnimationFrame(() => {
                var _a;
                const item = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.accordion__item');
                item === null || item === void 0 ? void 0 : item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            });
        }
    }
    handleKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.handleToggle(e);
        }
        else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            this.dispatchEvent(new CustomEvent('accordion-arrow-navigation', {
                bubbles: true,
                composed: true,
                detail: {
                    direction: e.key === 'ArrowDown' ? 'down' : 'up',
                    currentItem: this,
                },
            }));
        }
    }
    updated(changedProperties) {
        if (changedProperties.has('expanded')) {
            this.updatePanelHeight();
        }
    }
    updatePanelHeight() {
        var _a;
        const panel = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.accordion__panel');
        if (!panel)
            return;
        if (this.expanded) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    const content = panel.querySelector('.accordion__content');
                    if (content) {
                        const contentHeight = content.scrollHeight;
                        panel.style.maxHeight = `${contentHeight}px`;
                    }
                    // Allow overflow once expanded so nested Swiper carousels are not clipped.
                    const onTransitionEnd = () => {
                        panel.style.overflow = 'visible';
                        panel.removeEventListener('transitionend', onTransitionEnd);
                    };
                    panel.addEventListener('transitionend', onTransitionEnd);
                });
            });
        }
        else {
            panel.style.overflow = 'hidden';
            panel.style.maxHeight = '0';
        }
    }
    render() {
        const chevronIcon = $ `<img class="accordion__chevron" src="${img}" width="32" height="32" alt="" aria-hidden="true">`;
        const titleClass = this.imageUrl
            ? 'accordion__title accordion__title--with-image'
            : 'accordion__title accordion__title--basic';
        const imageSizeClass = this.imageSize
            ? `accordion__image--${this.imageSize}`
            : '';
        const imageClass = `accordion__image ${imageSizeClass}`.trim();
        const imageTemplate = this.imageUrl
            ? $ `<img src="${this.imageUrl}" alt="${this.imageDecorative === 'decorative' ? '' : this.imageAlt}" class="${imageClass}" loading="lazy" role="${this.imageDecorative === 'decorative' ? 'presentation' : ''}" aria-hidden="${this.imageDecorative === 'decorative' ? 'true' : 'false'}">`
            : '';
        const subtitleTemplate = this.subtitle
            ? $ `<span class="accordion__subtitle">${o(this.subtitle)}</span>`
            : '';
        const itemClasses = this.rtl
            ? 'accordion__item rtl-mode'
            : 'accordion__item';
        const textClass = this.titleColor
            ? `accordion__text title-color-${this.titleColor}`
            : 'accordion__text';
        return $ `<div class="${itemClasses}" dir="${this.rtl ? 'rtl' : 'ltr'}"><h3 class="accordion__header"><button id="${this.triggerId}" class="accordion__trigger" aria-controls="${this.contentId}" aria-expanded="${this.expanded}" type="button" ?disabled="${this.disabled}" @click="${this.handleToggle}" @keydown="${this.handleKeyDown}"><span class="${titleClass}">${imageTemplate}</span><div class="accordion__text-wrapper"><span class="${textClass}">${o(this.title)}</span> ${subtitleTemplate}</div>${chevronIcon}</button></h3><div id="${this.contentId}" class="accordion__panel" role="region" aria-labelledby="${this.triggerId}" ?hidden="${!this.expanded}"><div class="accordion__content"><slot name="accordion-content"></slot></div></div></div>`;
    }
}
AccordionItemUpdated.styles = css_248z;
__decorate([
    e({ type: String })
], AccordionItemUpdated.prototype, "title", void 0);
__decorate([
    e({ type: String })
], AccordionItemUpdated.prototype, "titleColor", void 0);
__decorate([
    e({ type: String })
], AccordionItemUpdated.prototype, "subtitle", void 0);
__decorate([
    e({ type: String })
], AccordionItemUpdated.prototype, "imageUrl", void 0);
__decorate([
    e({ type: String })
], AccordionItemUpdated.prototype, "imageAlt", void 0);
__decorate([
    e({ type: String })
], AccordionItemUpdated.prototype, "imageDecorative", void 0);
__decorate([
    e({ type: String })
], AccordionItemUpdated.prototype, "imageSize", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], AccordionItemUpdated.prototype, "expanded", void 0);
__decorate([
    e({ type: Boolean })
], AccordionItemUpdated.prototype, "disabled", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], AccordionItemUpdated.prototype, "rtl", void 0);
__decorate([
    t()
], AccordionItemUpdated.prototype, "contentId", void 0);
__decorate([
    t()
], AccordionItemUpdated.prototype, "triggerId", void 0);
customElements.define('accordion-item-updated', AccordionItemUpdated);

export { AccordionItemUpdated };
